import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const columnData = [
    {id: 'status', numeric: false, disablePadding: false, label: 'Status'},
    {id: 'startDate', numeric: false, disablePadding: false, label: 'Start'},
    {id: 'endDate', numeric: false, disablePadding: false, label: 'End'},
    {id: 'recordsCount', numeric: false, disablePadding: false, label: 'Records'}
];

const styles = theme => ({
    root: {
        width: '100%'
    },
    tableWrapper: {
        overflowX: 'auto',
    }
});

const CustomTableCell = withStyles(theme => ({
    head: {
        fontSize: 14,
        padding: 20
    },
    body: {
        fontSize: 12,
        padding: 20
    }
}))(TableCell);

class DataGroupInfoTable extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            status: '',
            startDate: '',
            endDate: '',
            recordsCount: 0,
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.groupData !== this.props.groupData) {
            this.setGroupData(nextProps.groupData);
        }
    }

    setGroupData(groupData) {
        if (groupData != null) {
            this.setState({
                status: groupData.status,
                startDate: groupData.startDate.split("T")[0],
                endDate: groupData.endDate.split("T")[0],
                recordsCount: groupData.records.toLocaleString("en-US")
            });
        }
    }

    render() {
        const {classes, groupData} = this.props;
        const {status, startDate, endDate, recordsCount} = this.state;

        return (
            <div className={classes.root}>
                <Paper>
                    <div className={classes.tableWrapper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {columnData.map(column => {
                                        return (
                                            <CustomTableCell
                                                key={column.id}
                                                numeric={column.numeric}
                                                padding={column.disablePadding ? 'none' : 'default'}>
                                                <b>{column.label}</b>
                                            </CustomTableCell>
                                        );
                                    }, this)}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <CustomTableCell style={{fontSize: 17}} component="th" scope="row" padding="default">
                                        {status}
                                    </CustomTableCell>
                                    <CustomTableCell style={{fontSize: 17}} component="th" scope="row" padding="default">
                                        {startDate}
                                    </CustomTableCell>
                                    <CustomTableCell style={{fontSize: 17}} component="th" scope="row" padding="default">
                                        {endDate}
                                    </CustomTableCell>
                                    <CustomTableCell style={{fontSize: 17}} component="th" scope="row" padding="default">
                                        {recordsCount}
                                    </CustomTableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </div>
                </Paper>
            </div>
        );
    }
}

DataGroupInfoTable.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DataGroupInfoTable);



// WEBPACK FOOTER //
// ./src/main/content/query/tables/DataGroupInfoTable.js